import React from 'react';
import { InputField, RadioButton } from 'components/Global';
import CheckboxField from 'components/Global/CheckboxField';
import { useSelector } from 'react-redux';
import { checkEmptyObject } from 'utils/functionality';
import { useSearchParams } from 'react-router-dom';

// ARRAY RADIO BUTTON
const arrayRadionButton = [
  {
    id: 'cfpf1',
    label: 'Harga Fixed',
    value: 'fixed',
  },
  {
    id: 'cfpf2',
    label: 'Harga Percentage',
    value: 'percentage',
  },
];

const arrayRadion2Button = [
  {
    id: 'gnrf1',
    label: 'Harga Fixed',
    value: 'fixed',
  },
  {
    id: 'gnrf2',
    label: 'Harga Percentage',
    value: 'percentage',
  },
];

const ServicesFormDetail = ({
  services,
  setServices,
  item,
  isSpecialAirportTransfer,
  setIsSpecialAirportTransfer,
  setIsMeetAndGreetNotActive,
  isMeetAndGreetNotActive,
  setIsFeeGetAndRideNotActive,
  isFeeGetAndRideNotActive,
}) => {
  const configsLocationData = useSelector((state) => state.configs.data);
  const { selected: selectedLocation } = useSelector((state) => state.rentalLocation);

  const [searchParams] = useSearchParams();
  const locationId = searchParams.get('location_id');

  const currentService = services?.find((ser) => ser.sub_service_id === item?.id);

  const checkActiveHandler = (e) => {
    const checked = e.target.checked;

    if (checked) {
      setServices((prevState) => [
        ...prevState,
        {
          sub_service_id: item?.id,
          driver_fee_type: '',
          driver_fee_amount: 0,
          is_active_fee_getandride: false,
          fee_getandride_type: '',
          fee_getandride_amount: 0,
        },
      ]);
    } else {
      const filteredServices = services?.filter((ser) => ser.sub_service_id !== item?.id);
      setServices(filteredServices);
    }
  };

  const priceFeeTypeHandler = (id) => {
    const newServices = services?.map((ser) => {
      if (ser.sub_service_id === item?.id) {
        return {
          ...ser,
          driver_fee_type: arrayRadionButton?.find((type) => type.id === id)?.value,
          driver_fee_amount: 0,
        };
      }

      return ser;
    });
    setServices(newServices);
  };

  const changeDriverFeeHandler = (e) => {
    const newServices = services?.map((ser) => {
      if (ser.sub_service_id === item?.id) {
        return {
          ...ser,
          driver_fee_amount: +e.target.value,
        };
      }

      return ser;
    });
    setServices(newServices);
  };

  const checkGetAndRideFeeHandler = (e) => {
    const checked = e.target.checked;
    const newServices = services?.map((ser) => {
      if (ser.sub_service_id === item?.id) {
        return {
          ...ser,
          is_active_fee_getandride: checked,
          fee_getandride_type: '',
          fee_getandride_amount: 0,
        };
      }

      return ser;
    });
    setServices(newServices);

    if (
      configsLocationData &&
      !checkEmptyObject(configsLocationData) &&
      locationId &&
      selectedLocation &&
      !checkEmptyObject(selectedLocation) &&
      checked
    ) {
      const parsedValue = JSON.parse(
        configsLocationData.data.find((item) => item.key === 'SETTING_INCLUDE_FEATURES_LOCATION')?.value,
      );

      if (parsedValue) {
        const feeGetAndRideActiveLocations = parsedValue.fee_getnride?.filter(
          (loc) => loc.location_id === selectedLocation.id && loc.sub_service_id === item?.id,
        );

        if (feeGetAndRideActiveLocations.length === 0) {
          setIsFeeGetAndRideNotActive([...isFeeGetAndRideNotActive, { status: true, service: item.name }]);
        }
      }
    }

    if (!checked) {
      const newFeeGetAndRideNotActive = isFeeGetAndRideNotActive.filter((ser) => ser.service !== item.name);
      setIsFeeGetAndRideNotActive(newFeeGetAndRideNotActive);
    }
  };

  const getAndRideFeeTypeHandler = (id) => {
    const newServices = services?.map((ser) => {
      if (ser.sub_service_id === item?.id) {
        return {
          ...ser,
          fee_getandride_type: arrayRadion2Button?.find((type) => type.id === id)?.value,
          fee_getandride_amount: 0,
        };
      }

      return ser;
    });
    setServices(newServices);
  };

  const changeGetAndRideFeeHandler = (e) => {
    const newServices = services?.map((ser) => {
      if (ser.sub_service_id === item?.id) {
        return {
          ...ser,
          fee_getandride_amount: +e.target.value,
        };
      }

      return ser;
    });
    setServices(newServices);
  };

  const changeMeetAndGreetBoardHandler = (e) => {
    const checked = e.target.checked;
    const newServices = services?.map((ser) => {
      if (ser.sub_service_id === item?.id) {
        return {
          ...ser,
          is_active_meet_greet_board: checked,
          fee_meet_greet_board_type: 'fixed',
        };
      }

      return ser;
    });
    setServices(newServices);

    if (
      configsLocationData &&
      !checkEmptyObject(configsLocationData) &&
      locationId &&
      selectedLocation &&
      !checkEmptyObject(selectedLocation) &&
      checked
    ) {
      const parsedValue = JSON.parse(
        configsLocationData.data.find((item) => item.key === 'SETTING_INCLUDE_FEATURES_LOCATION')?.value,
      );

      if (parsedValue) {
        const meetAndGreetActiveLocations = parsedValue.meet_greet?.filter(
          (loc) => loc.location_id === selectedLocation.id && loc.sub_service_id === item?.id,
        );

        if (meetAndGreetActiveLocations.length === 0) {
          setIsMeetAndGreetNotActive([...isMeetAndGreetNotActive, { status: true, service: item.name }]);
        }
      }
    }

    if (!checked) {
      const newMeetAndGreetNotActive = isMeetAndGreetNotActive.filter((ser) => ser.service !== item.name);
      setIsMeetAndGreetNotActive(newMeetAndGreetNotActive);
    }
  };

  const changeMeetAndGreetBoardFeeHandler = (e) => {
    const newServices = services?.map((ser) => {
      if (ser.sub_service_id === item?.id) {
        return {
          ...ser,
          fee_meet_greet_board_amount: +e.target.value,
        };
      }

      return ser;
    });
    setServices(newServices);
  };

  const changeDriverCarHandler = (e) => {
    setIsSpecialAirportTransfer(e.target.checked);
  };

  return (
    <div className="services-form">
      <div className="services-form__active-checkbox">
        <CheckboxField
          label="Active"
          name="active"
          value="active"
          checked={currentService}
          onChange={checkActiveHandler}
        />
        <CheckboxField
          label="Meet&Greet Board"
          name="meet-greet-board"
          value="meet-greet-board"
          checked={currentService?.is_active_meet_greet_board}
          onChange={changeMeetAndGreetBoardHandler}
        />
        <CheckboxField
          label="Fee Get&Ride"
          name="fee-get-and-ride"
          value="fee-get-and-ride"
          checked={currentService?.is_active_fee_getandride}
          onChange={checkGetAndRideFeeHandler}
        />
        {(item?.name === 'Airport Transfer' || item?.name === 'Charter') && (
          <CheckboxField
            label="Driver Car"
            name="driver-car"
            value="driver-car"
            checked={isSpecialAirportTransfer}
            onChange={changeDriverCarHandler}
          />
        )}
      </div>

      <div className="services-form__form">
        <div className="services-form__form__column">
          <InputField
            type="number"
            placeholder={currentService?.driver_fee_type === 'fixed' ? '0' : '0%'}
            label="Fee Driver"
            htmlFor="fee-driver"
            value={currentService?.driver_fee_amount || ''}
            onChange={changeDriverFeeHandler}
            disable={!currentService || !currentService?.driver_fee_type}
          />
          <div className="config-price">
            <RadioButton
              name="price-fee"
              data={arrayRadionButton}
              state={arrayRadionButton.find((type) => type.value === currentService?.driver_fee_type)?.id}
              setState={priceFeeTypeHandler}
              disable={!currentService}
            />
          </div>
        </div>
        <div className="services-form__form__column">
          <InputField
            type="number"
            placeholder={currentService?.fee_getandride_type === 'fixed' ? '0' : '0%'}
            label="Fee Get&Ride"
            htmlFor="fee-get&ride"
            value={currentService?.fee_getandride_amount || ''}
            onChange={changeGetAndRideFeeHandler}
            disable={!currentService?.is_active_fee_getandride || !currentService?.fee_getandride_type}
          />

          <div className="config-price">
            <RadioButton
              name="get-and-ride-fee"
              data={arrayRadion2Button}
              state={arrayRadion2Button.find((type) => type.value === currentService?.fee_getandride_type)?.id}
              setState={getAndRideFeeTypeHandler}
              disable={!currentService || !currentService?.is_active_fee_getandride}
            />
          </div>
        </div>

        <InputField
          type="number"
          placeholder={'0'}
          label="Biaya Meet&Greet Board"
          htmlFor="biaya-greet-board"
          value={currentService?.fee_meet_greet_board_amount || ''}
          onChange={changeMeetAndGreetBoardFeeHandler}
          disable={!currentService || !currentService?.is_active_meet_greet_board}
        />
      </div>
    </div>
  );
};

export default ServicesFormDetail;
